import { ChangeDetectionStrategy, Component, computed, inject, model, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../../../services/hmi-lookup.service';
import { SISTEM_PARAMETRE_SETLERI } from '@service/fikoyt-ui/src/lib/parametre-setleri/sistem-parametre-setleri';
import { AvatarService } from '@/src/app/servisler/avatar.service';
import { UniversalAvatarComponent } from '@/src/app/shared/components/universal-avatar/universal-avatar.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'personel-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule, NzDatePickerModule, NzDividerModule, NzIconModule, UniversalAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pe-edit">
      <div class="pe-baslik">
        <div class="pe-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <span>Personel Bilgileri</span>
      </div>

      <div class="pe-form">
        <div class="pe-foto-alan">
          <div class="pe-foto-onizleme">
            <universal-avatar
              [resimUrl]="fotoOnizleme()"
              [isim]="tamAd()"
              [boyut]="72"
              sekil="circle" />
          </div>
          <div class="pe-foto-islemler">
            <label class="pe-foto-sec">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
              </svg>
              <span>Fotoğraf Seç</span>
              <input type="file" accept="image/*" (change)="fotoSec($event)" hidden />
            </label>
            @if (deger('fotoUrl')) {
              <button type="button" class="pe-foto-sil" (click)="guncelle('fotoUrl', ''); guncelle('_fotoBase64', '')">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                Kaldır
              </button>
            }
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Ad <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('ad')" (ngModelChange)="guncelle('ad', $event)" placeholder="Adını girin..."/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Soyad <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('soyad')" (ngModelChange)="guncelle('soyad', $event)" placeholder="Soyadını girin..."/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-grup">
          <label>Sicil No</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('sicilNo')" (ngModelChange)="guncelle('sicilNo', $event)" placeholder="Sicil numarası"/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="pe-ayirici"></div>

        <div class="form-grup">
          <label>Departman</label>
          <div class="input-wrap">
            <nz-select [ngModel]="deger('departman')" (ngModelChange)="guncelle('departman', $event)"
              nzPlaceHolder="Departman seçin..." nzAllowClear nzShowSearch style="width:100%"
              (nzOnSearch)="departmanAra($event)" [nzDropdownRender]="deptFooterTpl"
              [nzCustomTemplate]="deptSeciliTpl">
              @for (d of lookup.departmanlar(); track d._id) {
                <nz-option [nzValue]="d.ad" [nzLabel]="d.ad + (d.kod ? ' (' + d.kod + ')' : '')" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">🏢</span><div class="sel-bilgi"><span class="sel-ad">{{ d.ad }}</span>@if (d.kod) { <span class="sel-detay">{{ d.kod }}</span> }</div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #deptSeciliTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">🏢</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <ng-template #deptFooterTpl>
              <nz-divider style="margin:4px 0"></nz-divider>
              <div class="aku-hizli-ekle" (mousedown)="$event.preventDefault()" (click)="yeniDepartmanEkle()">
                <nz-icon nzType="plus" /> Yeni Departman Ekle
              </div>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Unvan</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('unvan')" (ngModelChange)="guncelle('unvan', $event)" placeholder="Unvan"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Gorev</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('gorev')" (ngModelChange)="guncelle('gorev', $event)" placeholder="Gorev"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="pe-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Telefon</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('telefon')" (ngModelChange)="guncelle('telefon', $event)" placeholder="0(5XX) XXX XX XX"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>E-posta</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('eposta')" (ngModelChange)="guncelle('eposta', $event)" placeholder="ornek@firma.com"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-grup">
          <label>Ise Giris Tarihi</label>
          <div class="input-wrap">
            <nz-date-picker [ngModel]="deger('iseGirisTarihi')" (ngModelChange)="guncelle('iseGirisTarihi', $event)"
              nzPlaceHolder="Tarih secin..." style="width:100%">
            </nz-date-picker>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="pe-ayirici"></div>

        <div class="form-grup">
          <label>Iliskili Uye</label>
          <div class="input-wrap">
            <nz-select style="width:100%"
                       nzPlaceHolder="Uye secin..."
                       nzShowSearch nzAllowClear nzServerSearch
                       [ngModel]="deger('kullaniciId') || null"
                       (ngModelChange)="guncelle('kullaniciId', $event)"
                       (nzOnSearch)="lookup.uyeleriYukle($event)"
                       (nzOpenChange)="$event && lookup.uyeleriYukle()"
                       [nzCustomTemplate]="uyeSeciliTpl">
              @for (u of lookup.uyeler(); track u._id) {
                <nz-option [nzValue]="u._id" [nzLabel]="u.isim + ' ' + u.soyIsim" nzCustomContent>
                  <div class="sel-item">
                    <universal-avatar [resimUrl]="u.resimId ? avatar.profilResimUrl(u.resimId, '32x32') : ''" [isim]="u.isim + ' ' + u.soyIsim" [boyut]="24" />
                    <div class="sel-bilgi"><span class="sel-ad">{{ u.isim }} {{ u.soyIsim }}</span>@if (u.kullaniciAdi) { <span class="sel-detay">{{'@'}}{{ u.kullaniciAdi }}</span> }</div>
                  </div>
                </nz-option>
              }
            </nz-select>
            <ng-template #uyeSeciliTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">👤</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .pe-edit { display: flex; flex-direction: column; gap: 0; padding: 0; }

    .pe-baslik {
      display: flex; align-items: center; gap: 8px;
      padding: 12px 16px; margin-bottom: 4px; border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .pe-baslik-ikon {
      width: 32px; height: 32px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #3b82f6, #60a5fa);
      color: #fff; flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.35);
      position: relative;
    }

    .pe-baslik-ikon::after {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%;
      animation: shimmer 3s infinite linear;
      pointer-events: none;
    }

    .pe-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }

    .pe-foto-alan {
      display: flex; align-items: center; gap: 16px;
      padding: 12px 0; margin-bottom: 4px;
    }

    .pe-foto-onizleme {
      flex-shrink: 0; position: relative;
      border-radius: 50%; overflow: hidden;
      box-shadow: 0 4px 16px rgba(0,0,0,.12);
    }

    .pe-foto-islemler { display: flex; flex-direction: column; gap: 8px; }

    .pe-foto-sec {
      display: inline-flex; align-items: center; gap: 8px; cursor: pointer;
      padding: 4px 12px; border-radius: 6px; font-size: 12px; font-weight: 500;
      background: linear-gradient(135deg, rgba(59,130,246,.1), rgba(59,130,246,.05));
      color: #3b82f6; border: 1px solid rgba(59,130,246,.2);
      transition: all .2s ease;
    }
    .pe-foto-sec:hover { background: rgba(59,130,246,.15); border-color: rgba(59,130,246,.4); }

    .pe-foto-sil {
      display: inline-flex; align-items: center; gap: 4px; cursor: pointer;
      padding: 4px 8px; border-radius: 6px; font-size: 11px; font-weight: 500;
      background: transparent; color: #ef4444; border: 1px solid rgba(239,68,68,.2);
      transition: all .2s ease;
    }
    .pe-foto-sil:hover { background: rgba(239,68,68,.08); border-color: rgba(239,68,68,.4); }

    .pe-form { display: flex; flex-direction: column; gap: 16px; padding: 4px 2px; }

    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

    .pe-ayirici {
      height: 1px; margin: 2px 0; opacity: 0.4;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
    }

    .form-grup { display: flex; flex-direction: column; gap: 4px; }

    .form-grup label {
      font-size: 11px; font-weight: 500;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45));
      text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px;
      transition: color 0.2s ease;
    }

    .form-grup:focus-within label { color: var(--py-link, #1890ff); }

    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px;
      background: linear-gradient(90deg, #3b82f6, #60a5fa, #3b82f6);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0; pointer-events: none; z-index: 1;
    }

    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }

    .input-wrap input[nz-input],
    .input-wrap textarea[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9);
      border-radius: 8px; padding: 8px 12px; font-size: 13px;
      color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover,
    .input-wrap textarea[nz-input]:hover {
      border-color: var(--py-kenarlik-hover, #b3b3b3);
      background: var(--py-arkaplan-hover, #f5f5f5);
    }

    .input-wrap input[nz-input]:focus,
    .input-wrap textarea[nz-input]:focus {
      border-color: var(--py-kenarlik-aktif, #1890ff);
      background: var(--py-input-arka, #fff);
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
      outline: none;
    }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important;
      border-radius: 8px !important; min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-hover, #b3b3b3) !important;
      background: var(--py-arkaplan-hover, #f5f5f5) !important;
    }

    .input-wrap:focus-within ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-aktif, #1890ff) !important;
      background: var(--py-input-arka, #fff) !important;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
    }

    .input-wrap ::ng-deep .ant-picker {
      background: var(--py-arkaplan-hover, rgba(0,0,0,.02)) !important;
      border: 1px solid var(--py-kenarlik, rgba(0,0,0,.1)) !important;
      border-radius: 8px !important;
      min-height: 34px;
      width: 100% !important;
      font-size: 13px !important;
      transition: border-color .25s, box-shadow .25s, background .25s !important;
    }
    .input-wrap ::ng-deep .ant-picker input { font-size: 13px !important; color: var(--py-metin) !important; }

    .input-wrap:hover ::ng-deep .ant-picker {
      border-color: rgba(102,126,234,.3) !important;
      background: var(--py-arkaplan-hover, rgba(0,0,0,.01)) !important;
    }

    .input-wrap:focus-within ::ng-deep .ant-picker,
    .input-wrap ::ng-deep .ant-picker-focused {
      border-color: rgba(102,126,234,.5) !important;
      background: transparent !important;
      box-shadow: 0 0 0 2px rgba(102,126,234,.08) !important;
    }

    @keyframes shimmer {
      0% { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
  `],
})
export class PersonelEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);
  avatar = inject(AvatarService);
  private modal = inject(NzModalService);
  private vcr = inject(ViewContainerRef);

  constructor() { super(); this.lookup.departmanlariYukle(); this.lookup.uyeleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  tamAd = computed(() => {
    const ad = this.deger('ad');
    const soyad = this.deger('soyad');
    return ((ad || '') + ' ' + (soyad || '')).trim() || 'Personel';
  });

  fotoOnizleme = computed(() => {
    const ek = this.p();
    if (ek?._fotoBase64) return ek._fotoBase64;
    if (ek?.fotoUrl) return ek.fotoUrl;
    if (ek?._uyeResimId) return this.avatar.profilResimUrl(ek._uyeResimId, '96x96');
    if (ek?.kullaniciId) {
      const uye = this.lookup.uyeler().find(u => u._id === ek.kullaniciId);
      if (uye?.resimId) return this.avatar.profilResimUrl(uye.resimId, '96x96');
    }
    return '';
  });

  deger(alan: string): any {
    return paramDeger(this.p(), alan);
  }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }

  fotoSec(event: Event) {
    const input = event.target as HTMLInputElement;
    const dosya = input?.files?.[0];
    if (!dosya) return;
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      this.guncelle('fotoUrl', base64);
      this.guncelle('_fotoBase64', base64);
    };
    reader.readAsDataURL(dosya);
  }

  departmanAra(terim: string) { this.lookup.departmanlariYukle(terim); }

  async yeniDepartmanEkle() {
    const { PaylasKutusuComponent } = await import('@service/fikoyt-ui/src/lib/paylasim-sistemi/paylas-kutusu/paylas-kutusu.component');
    let bulunanSet: any;
    for (const g of SISTEM_PARAMETRE_SETLERI) { const s = g.altGruplar?.find((a: any) => a.id === 'hmi.departman'); if (s) { bulunanSet = s; break; } }
    if (!bulunanSet) { this.nzMessage.warning('Departman seti bulunamadı'); return; }
    const setKopya = JSON.parse(JSON.stringify(bulunanSet));
    const kart: any = { _id: Date.now().toString(36), vt: 'FikoYT.sistem.hareketler', yol: 'FikoYT.sistem.hareketler.kalem', turu: 'KART', gizlilik: 'Herkese Açık', uygulama: [], veri: { solSimge: { baslik: '🏢', renkArka: '#531dab', renkYazi: '#fff' }, icerikler: [{ _id: Date.now().toString(36), html: '', aciklama: '', sifre: null, ek: { turu: 'UYGULAMAICERIK', _secilenSetId: setKopya.id, parametreler: setKopya.parametreler || [], ...(setKopya.bilesen ? { bilesen: setKopya.bilesen } : {}) } }] } };
    const ref = this.modal.create({ nzTitle: '🏢 Yeni Departman', nzContent: PaylasKutusuComponent, nzWidth: 520, nzFooter: null, nzViewContainerRef: this.vcr });
    ref.afterOpen.subscribe(() => {
      const inst = ref.componentInstance;
      if (!inst) return;
      inst.kart = kart; inst.parametreSetleri = [JSON.parse(JSON.stringify(bulunanSet))]; inst.parametreSetiZorunlu = true; inst.taslakDevreDisi = true;
      inst.paylasimYapildi?.subscribe(() => { ref.close(); this.lookup.departmanlariYukle('', true); this.nzNotification.success('Eklendi', 'Departman kaydedildi'); });
      inst.CD?.detectChanges?.();
    });
  }
}
